module.exports = __webpack_public_path__ + "static/img/fun5.c3558133.png";